document.addEventListener('DOMContentLoaded', function () {
    const swiper = new Swiper('.video-swiper', {
        slidesPerView: 1,
        spaceBetween: 30,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 15,
            },
            750: {
                slidesPerView: 2,
                spaceBetween: 15,
            },
            990: {
                slidesPerView: 3,
                spaceBetween: 25,
            }
        },
    });

    const videoContainers = document.querySelectorAll('.blog-video-link');
    const videoOverlay = document.querySelector('.video-overlay');
    const videoOverlayContent = videoOverlay.querySelector('.video-overlay-content');
    const closeButtons = document.querySelectorAll('.close-overlay, .close-button');
    const body = document.body;

    videoContainers.forEach((container) => {
        const videoElement = container.querySelector('video');
        const videoPlaceholder = videoElement?.querySelector('source')?.src || '';
        const videoLink = container.closest('.swiper-slide')?.getAttribute('data-video-link') || videoPlaceholder;

        container.addEventListener('click', function () {
            videoOverlay.style.display = 'flex';
            body.classList.add('no-scroll');

            if (videoLink.includes('youtube.com') || videoLink.includes('youtu.be')) {
                let videoId = '';

                if (videoLink.includes('youtube.com/watch?v=')) {
                    videoId = new URL(videoLink).searchParams.get('v');
                } else if (videoLink.includes('youtu.be/')) {
                    videoId = videoLink.split('youtu.be/')[1].split('?')[0];
                }

                if (videoId) {
                    videoOverlayContent.innerHTML = `
                      <iframe width="798" height="450"
                        src="https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen>
                      </iframe>
                      <button class="close-button">Close</button>
                      <button class="close-overlay">&times;</button>
                    `;
                }
            } else {
                videoOverlayContent.innerHTML = `
                  <video class="fullscreen-video" controls autoplay playsinline muted>
                    <source src="${videoPlaceholder}" type="video/mp4">
                  </video>
                  <button class="close-button">Close</button>
                  <button class="close-overlay">&times;</button>
                `;
            }

            document.querySelectorAll('.close-overlay, .close-button').forEach(button => {
                button.addEventListener('click', closeVideoOverlay);
            });
        });
    });

    function closeVideoOverlay() {
        videoOverlay.style.display = 'none';
        videoOverlayContent.innerHTML = '';
        body.classList.remove('no-scroll');
    }

    videoOverlay.addEventListener('click', function (e) {
        if (e.target === videoOverlay) {
            closeVideoOverlay();
        }
    });

    closeButtons.forEach(button => {
        button.addEventListener('click', closeVideoOverlay);
    });
});
